import React, { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setupAuthInterceptor, setupApiClient } from '../services/apiClient';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (isLoaded) {
      setupAuthInterceptor(getToken);
      setupApiClient(getToken);
    }
  }, [getToken, isLoaded]);

  if (!isLoaded) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-gray-950 text-white">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent"></div>
          <p className="text-sm text-gray-400">Loading session...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
